// import OverView from "./OverView/OverViewMain";
// import KYCMain from "./KYC/KYCMain";
// import KYCMainNew from "./KYC/KYCMainNew";

// export default function MainContent({
//   activeSubTab,
//   activeTab,
//   status,
//   admin,
//   allStatus,
//   handleBack
// }) {
//   const [dateFilterPopup, setDateFilterPopup] = useState({
//       show: false,
//    from: moment().subtract(6, "days").format("YYYY-MM-DD"),
//   to: moment().format("YYYY-MM-DD"),
//     });
//     const [dateType , setDateType] = useState('7')


//   const tabComponentMap = {
//     overview: <OverView leadStatus={status} admin={admin} allStatus={allStatus} handleBack={handleBack} />,
//     kyc: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//     creditInfo: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//     creditWritting: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//     loanProcess: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//     payment: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//     platformApi: <KYCMain activeSubTab={activeSubTab} handleBack={handleBack} />,
//   };

//   return <>{tabComponentMap[activeTab] || null}</>;
// }

import { useEffect, useState } from "react";
import moment from "moment";

import OverView from "./OverView/OverViewMain";
import KYCMain from "./KYC/KYCMain";
import KYCMainNew from "./KYC/KYCMainNew";
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';

export default function MainContent({
  activeSubTab,
  activeTab,
  status,
  admin,
  allStatus,
  handleBack,
}) {
  const dispatch = useDispatch();
  const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
  const [dateFilterPopup, setDateFilterPopup] = useState({
    from: ReducerFrom,
    to: ReducerTo,
  });

  

  const [dateType, setDateType] = useState("custom");

  useEffect(() => {
    if(dateType == "custom"){
      setDateFilterPopup({
        from: ReducerFrom,
        to: ReducerTo,
      })
    }
  }, [ReducerFrom, ReducerTo]);


  const handleClearDate = () => {
    setDateFilterPopup((prev) => ({
      from: moment().subtract(6, "days").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    }));
    // setDateType("7");
  };

  const updateDateRange = (from, to, type = "custom") => {
    if(type == "custom"){
      dispatch({ type: FILTER_ACTION, payload: { fromDate: from } });
      dispatch({ type: FILTER_ACTION, payload: { toDate: to } });
    }
    setDateFilterPopup({ from, to });

  };


  const commonProps = {
    dateFilterPopup,
    setDateFilterPopup,
    dateType,
    setDateType,
    updateDateRange
  };

  // ✅ Tab Mapping
  const tabComponentMap = {
    overview: (
      <OverView
        {...commonProps}
        leadStatus={status}
        admin={admin}
        allStatus={allStatus}
        handleBack={handleBack}
      />
    ),

    kyc: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),

    creditInfo: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),

    creditWritting: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),

    loanProcess: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),

    payment: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),

    platformApi: (
      <KYCMain
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
      />
    ),
  };

  return <>{tabComponentMap[activeTab] || null}</>;
}